// extracted by mini-css-extract-plugin
export default {"pos":"Footer_pos__LCxbQ"};